import CampaignActionTypes from './types';

export const fetchCampaignsStart = () => ({
  type: CampaignActionTypes.FETCH_CAMPAIGNS_START,
});

export const fetchCampaignsSuccess = campaigns => ({
  type: CampaignActionTypes.FETCH_CAMPAIGNS_SUCCESS,
  payload: campaigns,
});

export const fetchCampaignDetailsStart = campaignId => ({
  type: CampaignActionTypes.FETCH_CAMPAIGN_DETAILS_START,
  payload: campaignId,
});

export const fetchCampaignDetailsSuccess = campaign => ({
  type: CampaignActionTypes.FETCH_CAMPAIGN_DETAILS_SUCCESS,
  payload: campaign,
});

export const fetchCampaignGiftsStart = campaignId => ({
  type: CampaignActionTypes.FETCH_CAMPAIGN_GIFTS_START,
  payload: campaignId,
});

export const fetchCampaignGiftsSuccess = gifts => ({
  type: CampaignActionTypes.FETCH_CAMPAIGN_GIFTS_SUCCESS,
  payload: gifts,
});

export const saveCamapignGiftStart = (gift, file) => ({
  type: CampaignActionTypes.SAVE_CAMPAIGN_GIFT_START,
  payload: { gift, file },
});

export const saveNewCampaignStart = (campaign, campaignImageFile, gifts) => ({
  type: CampaignActionTypes.SAVE_NEW_CAMPAIGN_START,
  payload: { campaign, campaignImageFile, gifts },
});

export const saveCampaignStart = (campaign, campaignImageFile, campaignId) => ({
  type: CampaignActionTypes.SAVE_CAMPAIGN_START,
  payload: { campaign, campaignImageFile, campaignId },
});

export const setCampaignState = state => ({
  type: CampaignActionTypes.SET_CAMPAIGN_STATE,
  payload: state,
});

export const addCampaignGift = gift => ({
  type: CampaignActionTypes.ADD_CAMPAIGN_GIFT,
  payload: gift,
});

export const deleteCampaignGift = giftId => ({
  type: CampaignActionTypes.DELETE_CAMPAIGN_GIFT,
  payload: { giftId },
});

export const generateCampaignQRCodes = (campaignId, amount, caller) => ({
  type: CampaignActionTypes.GENERATE_CAMPAIGN_QR_CODES,
  payload: { campaignId, amount, caller },
});

export const generateLoosersReportForCampaign = campaignId => ({
  type: CampaignActionTypes.GENERATE_LOOSERS_REPORT_FOR_CAMPAIGN,
  payload: { campaignId },
});

export const changeCampaignPublishingStatus = (willPublish, campaignId) => ({
  type: CampaignActionTypes.CHANGE_CAMPAIGN_PUBLISHING_STATUS,
  payload: { campaignId, willPublish },
});

export const editCampaignGift = gift => ({
  type: CampaignActionTypes.EDIT_CAMPAIGN_GIFT,
  payload: { gift },
});

export const fetchCampaignGiftOperators = () => ({
  type: CampaignActionTypes.FETCH_CAMPAIGN_GIFT_OPERATORS,
});
